import actionCreatorFactory from 'typescript-fsa';

import reduxConfig from '../../../store/config';
import { DryMatterItem } from './appIngredients.types';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/appIngredients');

export const getIngredientDrymatters = actionCreator.async<string, DryMatterItem[]>('GET_INGREDIENT_DRYMATTERS');
